
import * as angular from "angular";

export class DelayService {

    static $inject = ["$q", "$timeout"];

    constructor(
        private $q: angular.IQService,
        private $timeout: angular.ITimeoutService) {
    }

    public delayPromiseByUpTo<T>(promise: angular.IPromise<T>, delay: number): angular.IPromise<T> {
        var timeoutPromise = this.$timeout(() => { }, delay);

        return this.$q
            .all([promise, timeoutPromise])
            .then(([p1, p2]) => {
                return p1;
            });
    }
}
